/**
 * DÉPRÉCIÉ : Utiliser UnifiedErrorService à la place.
 * Ce fichier est conservé pour la compatibilité descendante.
 */
import { errorService } from './unifiedErrorService';

export const handleApiError = (error: unknown, callback?: (message: string, type: 'error' | 'warning') => void) => {
    const appError = errorService.handleError(error, 'Legacy:Api');
    if (callback) {
        const toastType = appError.severity === 'critical' || appError.severity === 'high' ? 'error' : 'warning';
        callback(appError.message, toastType);
    }
    return appError;
};

export const withRetry = <T>(
    fn: () => Promise<T>,
    retries: number = 2,
    delay: number = 1000
): Promise<T> => {
    return errorService.withResilience(fn, 'Legacy:Retry', { retries, delay });
};

export const parseValidationError = (error: unknown) => {
    const appError = errorService.handleError(error);
    return (appError.details as { errors?: { field: string; message: string }[] })?.errors?.[0] || null;
};
